import { useState, useRef, useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import axios from "axios";
import { API } from "@/App";
import { toast } from "sonner";
import { WELCOME_MESSAGE, FALLBACK_REPLY } from "./advisorModel";

export const useAdvisor = () => {
  const { userId } = useParams();
  const [searchParams] = useSearchParams();
  const contextParam = searchParams.get("context");
  const [messages, setMessages] = useState([WELCOME_MESSAGE]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [contextProcessed, setContextProcessed] = useState(false);
  const scrollRef = useRef(null);

  // "Help me execute" deep link: pre-fill the question and auto-send it once
  useEffect(() => {
    if (!contextParam || contextProcessed) return;
    setContextProcessed(true);
    setInput(decodeURIComponent(contextParam));
    setTimeout(() => document.querySelector('[data-testid="advisor-send-btn"]')?.click(), 500);
  }, [contextParam, contextProcessed]);

  useEffect(() => {
    const viewport = scrollRef.current?.querySelector("[data-radix-scroll-area-viewport]") || scrollRef.current;
    if (viewport) viewport.scrollTop = viewport.scrollHeight;
  }, [messages]);

  const send = async () => {
    if (!input.trim()) return;
    const question = input;
    setInput("");
    setMessages((prev) => [...prev, { role: "user", content: question }]);
    setLoading(true);
    try {
      const res = await axios.post(`${API}/agent/insights`, { userId, contextType: "advisor", context: { question, conversationHistory: messages } });
      setMessages((prev) => [...prev, { role: "assistant", content: res.data.insights }]);
    } catch (err) {
      console.error("Error:", err);
      toast.error("Failed to get response");
      setMessages((prev) => [...prev, { role: "assistant", content: FALLBACK_REPLY }]);
    } finally {
      setLoading(false);
    }
  };

  return { messages, input, setInput, loading, scrollRef, send };
};
